export default "__VITE_ASSET__DeeuDfk8__"